var _style, _g, _g2, _polygon, _rect, _defs, _rect2, _rect3, _rect4, _rect5, _g3, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line10, _line11, _line12, _line13, _line14, _line15, _line16, _line17, _line18, _line19, _line20, _line21, _line22, _line23, _line24, _line25, _line26, _line27, _line28, _line29, _line30, _line31, _line32, _line33, _line34, _line35, _line36, _line37, _line38, _line39, _line40, _line41, _line42, _line43, _line44, _line45, _line46, _line47, _line48, _line49, _line50, _line51, _line52, _line53, _line54, _line55, _line56, _path, _path2, _path3, _path4, _line57, _line58, _line59, _line60, _line61, _line62, _line63, _line64, _line65, _line66, _line67, _line68, _line69, _path5, _path6, _g4, _path7, _path8, _line70, _line71, _line72, _line73, _line74, _line75, _line76, _line77, _line78, _line79, _line80, _line81, _line82, _line83, _line84, _line85;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAboutuspageBro(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 414.7 304.3",
    style: {
      enableBackground: "new 0 0 414.7 304.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#1B6B93;}\r\n\t.st1{opacity:0.7;fill:#FFFFFF;enable-background:new    ;}\r\n\t.st2{opacity:0.5;}\r\n\t.st3{fill:#FFFFFF;}\r\n\t.st4{opacity:0.4;fill:#FFFFFF;enable-background:new    ;}\r\n\t.st5{fill:none;stroke:#263238;stroke-linecap:round;stroke-linejoin:round;}\r\n\t.st6{fill:#263238;}\r\n\t.st7{clip-path:url(#SVGID_00000111887236604230551050000012741762922896385199_);}\r\n\t.st8{opacity:0.17;enable-background:new    ;}\r\n\t.st9{fill:#1B6B93;stroke:#263238;stroke-miterlimit:10;}\r\n\t.st10{opacity:0.17;}\r\n\t.st11{fill:none;stroke:#263238;stroke-width:3;stroke-linecap:round;stroke-linejoin:round;}\r\n\t.st12{opacity:0.92;fill:#FFFFFF;enable-background:new    ;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M338.7,43.6c0,0-42.7-44.1-110.3-42S103.2,46.4,55.5,79.9S-5,165.3,22.8,205.8s71.9,23.5,128.1,49.8 s66.8,41.3,129.5,34.9s110.3-71.9,103.2-141.6S338.7,43.6,338.7,43.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M338.7,43.6c0,0-42.7-44.1-110.3-42S103.2,46.4,55.5,79.9S-5,165.3,22.8,205.8s71.9,23.5,128.1,49.8 s66.8,41.3,129.5,34.9s110.3-71.9,103.2-141.6S338.7,43.6,338.7,43.6z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M68.4,146.5c0.1,0-0.7-3.7-0.8-4c-0.9-2.7-4.1-7.3-7.2-7.3c-2.1,0.1-3.7,1.8-3.6,3.8c0,0.1,0,0.3,0,0.4 c0.2,2.2,2.2,4.1,4,5.2C62.9,145.9,68.4,146.5,68.4,146.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M74.4,121.4c-2.9,1.1-4.4,6.5-4.3,9.3c0,0.2,0.6,4,0.6,4h0.1c-0.2,0.9-0.5,1.8-0.7,2.8c-0.4,1.9-0.9,4-1.3,6.4 c-0.4,2.5-0.7,5.1-0.8,7.6c-0.2,2.9-0.1,5.7,0.3,8.6v0.1c-0.4-0.8-1.5-3.1-1.7-3.3c-1.5-2.3-5.9-6-8.9-5.1c-2,0.6-3.1,2.7-2.5,4.6 c0,0.1,0.1,0.2,0.1,0.4c0.8,2.1,3.2,3.4,5.2,3.9c2.3,0.6,7.3-0.1,7.7-0.2c0.4,2.9,1.1,5.8,1.9,8.6c0.5,1.6,1,3.3,1.5,4.9 c-0.3-0.7-0.7-1.3-0.7-1.4c-1.5-2.3-5.9-6-8.9-5.1c-2,0.6-3.1,2.7-2.5,4.6c0,0.1,0.1,0.2,0.1,0.4c0.8,2.1,3.2,3.4,5.2,3.9 c2,0.5,6.4,0,7.5-0.1c0.2,0.6,0.4,1.2,0.6,1.9c1,3,2.1,6,3,8.9c0.3,1,0.6,2.1,0.9,3.1c-0.3-0.6-0.6-1.2-0.6-1.2 c-1.5-2.4-5.9-6-8.9-5.1c-2,0.6-3.1,2.7-2.5,4.6c0,0.1,0.1,0.2,0.1,0.4c0.8,2.1,3.2,3.4,5.2,3.9s5.9,0.1,7.3-0.1 c0.3,1.1,0.5,2.1,0.8,3.2c0.1,0.7,0.3,1.4,0.4,2.1l0.3,2.1c0.1,1.4,0.3,2.8,0.4,4.1c0.1,0.9,0.1,1.8,0.2,2.7c-0.3-1-1-3.1-1-3.2 c-1.1-2.2-2.8-4.1-4.8-5.5c-0.1-0.3-0.2-0.5-0.4-0.7c-1.1-1.7-3.4-2.2-5.1-1.1c-0.1,0.1-0.2,0.1-0.3,0.2c-2.4,2-1.8,7.7-0.7,10.2 c0.1,0.1,1,1.7,1.5,2.7l-1.3-1.6c-0.9-1.1-1.8-2.1-2.7-3.2c-0.5-0.5-1-1-1.5-1.6c-0.5-0.5-1.1-1-1.6-1.6c-1.3-1.2-2.6-2.4-4-3.5 c0.9-0.8,4.2-3.5,5.2-5.4s1.6-4.5,0.6-6.5c-0.8-1.9-3-2.7-4.9-1.8c-0.1,0.1-0.2,0.1-0.3,0.2c-2.7,1.7-2.9,7.3-2.2,10 c0,0.2,0.8,2.1,1.2,3.1c-0.8-0.7-1.7-1.4-2.5-2c-2.5-1.9-5-3.8-7.6-5.6l-2.3-1.7c0.3-0.3,4.3-3.5,5.3-5.6c0.9-1.9,1.6-4.5,0.6-6.5 c-0.8-1.9-3-2.7-4.9-1.9c-0.1,0.1-0.2,0.1-0.4,0.2c-2.7,1.7-2.9,7.3-2.2,10c0.1,0.2,1.1,2.9,1.4,3.6c-1.7-1.3-3.4-2.5-5-3.9 c-2.2-1.8-4.3-3.7-6.2-5.8c0.2-0.1,4.3-3.5,5.4-5.6c0.9-1.9,1.6-4.5,0.6-6.5c-0.9-1.9-3.1-2.7-4.9-1.8c-0.1,0.1-0.2,0.1-0.3,0.2 c-2.7,1.7-2.9,7.3-2.2,10c0.1,0.2,0.8,2.3,1.2,3.2L33,178c-1.9-2.1-3.6-4.4-5.1-6.8c-0.8-1.3-1.6-2.6-2.2-3.9 c0.8-0.5,4.6-3,5.8-4.9s2.1-4.3,1.3-6.4c-0.6-1.9-2.7-3-4.7-2.3c-0.1,0-0.2,0.1-0.3,0.1c-2.8,1.4-3.7,7-3.3,9.7 c0,0.1,0.4,1.7,0.7,2.8c-0.3-0.6-0.6-1.2-0.9-1.8c-1-2.1-1.8-4.1-2.6-5.9c-0.4-1-0.7-2-1-2.8c0.5-0.9,2.7-4.8,2.9-7 s-0.1-4.8-1.8-6.3c-1.5-1.4-3.8-1.4-5.3,0c-0.1,0.1-0.2,0.2-0.3,0.3c-1.9,2.5-0.1,7.9,1.5,10.2c0.1,0.2,2.7,3,2.7,3v-0.1 c0.3,0.9,0.6,1.8,0.9,2.7c0.7,1.8,1.4,3.9,2.4,6c1,2.3,2.2,4.6,3.5,6.8c1.5,2.5,3.1,4.8,5,7l0.1,0.1c-0.8-0.5-3-1.8-3.2-1.8 c-2.6-1.1-8.2-1.7-10.3,0.6c-1.3,1.6-1.1,3.9,0.5,5.2c0.1,0.1,0.2,0.2,0.3,0.2c1.8,1.3,4.5,1,6.5,0.4c2.2-0.7,6-4.1,6.3-4.4 c2,2.2,4.1,4.2,6.3,6.1c1.3,1.1,2.6,2.2,4,3.3c-0.7-0.4-1.3-0.7-1.4-0.8c-2.6-1.1-8.2-1.7-10.2,0.6c-1.3,1.6-1.1,3.9,0.5,5.2 c0.1,0.1,0.2,0.2,0.3,0.2c1.8,1.3,4.5,1,6.5,0.4s5.3-3.5,6.2-4.3l1.6,1.2c2.5,1.9,5,3.8,7.4,5.8c0.8,0.7,1.7,1.4,2.5,2.1 c-0.6-0.4-1.1-0.6-1.2-0.7c-2.6-1.1-8.2-1.7-10.2,0.6c-1.3,1.6-1.1,3.9,0.5,5.2c0.1,0.1,0.2,0.2,0.3,0.2c1.8,1.3,4.5,1,6.5,0.4 s5-3.2,6-4.1c0.8,0.7,1.6,1.5,2.4,2.2c0.5,0.5,1,1,1.5,1.6l1.4,1.6c0.9,1.1,1.8,2.1,2.6,3.2c0.6,0.7,1.1,1.5,1.7,2.2 c-0.8-0.7-2.5-2-2.7-2.1c-2.4-1.5-7.8-3-10.2-0.9c-1.5,1.4-1.7,3.7-0.3,5.2c0.1,0.1,0.2,0.2,0.3,0.3c1.6,1.5,4.3,1.7,6.4,1.4 c2.3-0.4,6.4-3,6.9-3.4c0.9,1.2,1.8,2.3,2.6,3.4c2.8,3.8,4.9,7.1,6.4,9.5l0.2,0.2l1.9-0.9l-0.3-0.5c-1.6-2.3-3.8-5.6-6.7-9.4 c-0.9-1.2-1.9-2.5-2.9-3.8c1.1-1.2,2.1-2.4,3-3.7c2.2,0.9,6.8,0.9,7.4,0.9c0.1,1.5,0.2,2.9,0.2,4.3c0.2,4.7,0.2,8.7,0.1,11.4 c0,0.1,0,0.2,0,0.3l2.1-1c0-2.7-0.1-6.4-0.4-10.8c-0.1-1.5-0.2-3.1-0.4-4.8c0.6-0.1,5.4-1.4,7.1-2.8c1.6-1.3,3.4-3.4,3.3-5.6 c0-2-1.6-3.7-3.7-3.7c-0.1,0-0.3,0-0.4,0c-3.1,0.4-5.7,5.4-6.2,8.2c0,0.2-0.2,2-0.2,3.1c-0.1-0.7-0.1-1.3-0.2-2 c-0.1-1.4-0.3-2.7-0.5-4.2c-0.1-0.7-0.2-1.4-0.4-2.1s-0.3-1.5-0.4-2.2c-0.4-1.7-0.8-3.4-1.3-5.1c1.2-0.1,5.5-0.6,7.3-1.7 s3.8-2.9,4.1-5.1c0.3-2-1.1-3.9-3.1-4.2c-0.1,0-0.3,0-0.4,0c-3.1-0.1-6.5,4.5-7.4,7.1c-0.1,0.2-0.5,2.1-0.7,3.2c-0.3-1-0.6-2-1-3.1 c-1-3-2.1-5.9-3.2-8.9l-1-2.7c0.4,0,5.5-0.5,7.5-1.7c1.8-1,3.8-2.9,4.1-5.1c0.3-2-1-3.9-3.1-4.2c-0.1,0-0.3,0-0.4,0 c-3.1-0.1-6.5,4.5-7.4,7.1c-0.1,0.2-0.7,3-0.8,3.8c-0.7-2-1.4-4-2-6c-0.8-2.7-1.5-5.5-2-8.2c0.2,0,5.5-0.5,7.6-1.7 c1.8-1.1,3.8-2.9,4.1-5.1c0.3-2-1.1-3.9-3.1-4.2c-0.1,0-0.3,0-0.4,0c-3.1-0.1-6.5,4.5-7.4,7.1c-0.1,0.2-0.6,2.3-0.8,3.4h-0.2 c-0.4-2.8-0.6-5.7-0.5-8.5c0-1.6,0.2-3.1,0.3-4.5c1,0,5.6,0,7.6-0.9s4.1-2.4,4.6-4.6c0.5-2-0.6-4-2.6-4.6c-0.1,0-0.3-0.1-0.4-0.1 c-3.1-0.4-6.9,3.8-8.1,6.3c-0.1,0.1-0.6,1.6-0.9,2.7c0.1-0.7,0.1-1.3,0.2-2c0.3-2.4,0.8-4.5,1.2-6.4c0.2-1.1,0.5-2,0.7-2.9 c1-0.5,4.9-2.6,6.3-4.2c1.4-1.6,2.5-4.1,2-6.2c-0.4-2-2.4-3.3-4.4-2.9C74.8,121.3,74.6,121.3,74.4,121.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M17.8,169.7c2.4-0.1,7.3-2.6,7.4-2.6s-2.6-2.7-2.8-2.9c-2.2-1.7-7.5-3.8-10.1-2.1c-1.7,1.2-2.1,3.5-0.9,5.2 c0.1,0.1,0.2,0.2,0.2,0.3C13,169.3,15.7,169.8,17.8,169.7z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M68.4,146.5c0.1,0-0.7-3.7-0.8-4c-0.9-2.7-4.1-7.3-7.2-7.3c-2.1,0.1-3.7,1.8-3.6,3.8c0,0.1,0,0.3,0,0.4 c0.2,2.2,2.2,4.1,4,5.2C62.9,145.9,68.4,146.5,68.4,146.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M74.4,121.4c-2.9,1.1-4.4,6.5-4.3,9.3c0,0.2,0.6,4,0.6,4h0.1c-0.2,0.9-0.5,1.8-0.7,2.8 c-0.4,1.9-0.9,4-1.3,6.4c-0.4,2.5-0.7,5.1-0.8,7.6c-0.2,2.9-0.1,5.7,0.3,8.6v0.1c-0.4-0.8-1.5-3.1-1.7-3.3c-1.5-2.3-5.9-6-8.9-5.1 c-2,0.6-3.1,2.7-2.5,4.6c0,0.1,0.1,0.2,0.1,0.4c0.8,2.1,3.2,3.4,5.2,3.9c2.3,0.6,7.3-0.1,7.7-0.2c0.4,2.9,1.1,5.8,1.9,8.6 c0.5,1.6,1,3.3,1.5,4.9c-0.3-0.7-0.7-1.3-0.7-1.4c-1.5-2.3-5.9-6-8.9-5.1c-2,0.6-3.1,2.7-2.5,4.6c0,0.1,0.1,0.2,0.1,0.4 c0.8,2.1,3.2,3.4,5.2,3.9c2,0.5,6.4,0,7.5-0.1c0.2,0.6,0.4,1.2,0.6,1.9c1,3,2.1,6,3,8.9c0.3,1,0.6,2.1,0.9,3.1 c-0.3-0.6-0.6-1.2-0.6-1.2c-1.5-2.4-5.9-6-8.9-5.1c-2,0.6-3.1,2.7-2.5,4.6c0,0.1,0.1,0.2,0.1,0.4c0.8,2.1,3.2,3.4,5.2,3.9 s5.9,0.1,7.3-0.1c0.3,1.1,0.5,2.1,0.8,3.2c0.1,0.7,0.3,1.4,0.4,2.1l0.3,2.1c0.1,1.4,0.3,2.8,0.4,4.1c0.1,0.9,0.1,1.8,0.2,2.7 c-0.3-1-1-3.1-1-3.2c-1.1-2.2-2.8-4.1-4.8-5.5c-0.1-0.3-0.2-0.5-0.4-0.7c-1.1-1.7-3.4-2.2-5.1-1.1c-0.1,0.1-0.2,0.1-0.3,0.2 c-2.4,2-1.8,7.7-0.7,10.2c0.1,0.1,1,1.7,1.5,2.7l-1.3-1.6c-0.9-1.1-1.8-2.1-2.7-3.2c-0.5-0.5-1-1-1.5-1.6c-0.5-0.5-1.1-1-1.6-1.6 c-1.3-1.2-2.6-2.4-4-3.5c0.9-0.8,4.2-3.5,5.2-5.4s1.6-4.5,0.6-6.5c-0.8-1.9-3-2.7-4.9-1.8c-0.1,0.1-0.2,0.1-0.3,0.2 c-2.7,1.7-2.9,7.3-2.2,10c0,0.2,0.8,2.1,1.2,3.1c-0.8-0.7-1.7-1.4-2.5-2c-2.5-1.9-5-3.8-7.6-5.6l-2.3-1.7c0.3-0.3,4.3-3.5,5.3-5.6 c0.9-1.9,1.6-4.5,0.6-6.5c-0.8-1.9-3-2.7-4.9-1.9c-0.1,0.1-0.2,0.1-0.4,0.2c-2.7,1.7-2.9,7.3-2.2,10c0.1,0.2,1.1,2.9,1.4,3.6 c-1.7-1.3-3.4-2.5-5-3.9c-2.2-1.8-4.3-3.7-6.2-5.8c0.2-0.1,4.3-3.5,5.4-5.6c0.9-1.9,1.6-4.5,0.6-6.5c-0.9-1.9-3.1-2.7-4.9-1.8 c-0.1,0.1-0.2,0.1-0.3,0.2c-2.7,1.7-2.9,7.3-2.2,10c0.1,0.2,0.8,2.3,1.2,3.2L33,178c-1.9-2.1-3.6-4.4-5.1-6.8 c-0.8-1.3-1.6-2.6-2.2-3.9c0.8-0.5,4.6-3,5.8-4.9s2.1-4.3,1.3-6.4c-0.6-1.9-2.7-3-4.7-2.3c-0.1,0-0.2,0.1-0.3,0.1 c-2.8,1.4-3.7,7-3.3,9.7c0,0.1,0.4,1.7,0.7,2.8c-0.3-0.6-0.6-1.2-0.9-1.8c-1-2.1-1.8-4.1-2.6-5.9c-0.4-1-0.7-2-1-2.8 c0.5-0.9,2.7-4.8,2.9-7s-0.1-4.8-1.8-6.3c-1.5-1.4-3.8-1.4-5.3,0c-0.1,0.1-0.2,0.2-0.3,0.3c-1.9,2.5-0.1,7.9,1.5,10.2 c0.1,0.2,2.7,3,2.7,3v-0.1c0.3,0.9,0.6,1.8,0.9,2.7c0.7,1.8,1.4,3.9,2.4,6c1,2.3,2.2,4.6,3.5,6.8c1.5,2.5,3.1,4.8,5,7l0.1,0.1 c-0.8-0.5-3-1.8-3.2-1.8c-2.6-1.1-8.2-1.7-10.3,0.6c-1.3,1.6-1.1,3.9,0.5,5.2c0.1,0.1,0.2,0.2,0.3,0.2c1.8,1.3,4.5,1,6.5,0.4 c2.2-0.7,6-4.1,6.3-4.4c2,2.2,4.1,4.2,6.3,6.1c1.3,1.1,2.6,2.2,4,3.3c-0.7-0.4-1.3-0.7-1.4-0.8c-2.6-1.1-8.2-1.7-10.2,0.6 c-1.3,1.6-1.1,3.9,0.5,5.2c0.1,0.1,0.2,0.2,0.3,0.2c1.8,1.3,4.5,1,6.5,0.4s5.3-3.5,6.2-4.3l1.6,1.2c2.5,1.9,5,3.8,7.4,5.8 c0.8,0.7,1.7,1.4,2.5,2.1c-0.6-0.4-1.1-0.6-1.2-0.7c-2.6-1.1-8.2-1.7-10.2,0.6c-1.3,1.6-1.1,3.9,0.5,5.2c0.1,0.1,0.2,0.2,0.3,0.2 c1.8,1.3,4.5,1,6.5,0.4s5-3.2,6-4.1c0.8,0.7,1.6,1.5,2.4,2.2c0.5,0.5,1,1,1.5,1.6l1.4,1.6c0.9,1.1,1.8,2.1,2.6,3.2 c0.6,0.7,1.1,1.5,1.7,2.2c-0.8-0.7-2.5-2-2.7-2.1c-2.4-1.5-7.8-3-10.2-0.9c-1.5,1.4-1.7,3.7-0.3,5.2c0.1,0.1,0.2,0.2,0.3,0.3 c1.6,1.5,4.3,1.7,6.4,1.4c2.3-0.4,6.4-3,6.9-3.4c0.9,1.2,1.8,2.3,2.6,3.4c2.8,3.8,4.9,7.1,6.4,9.5l0.2,0.2l1.9-0.9l-0.3-0.5 c-1.6-2.3-3.8-5.6-6.7-9.4c-0.9-1.2-1.9-2.5-2.9-3.8c1.1-1.2,2.1-2.4,3-3.7c2.2,0.9,6.8,0.9,7.4,0.9c0.1,1.5,0.2,2.9,0.2,4.3 c0.2,4.7,0.2,8.7,0.1,11.4c0,0.1,0,0.2,0,0.3l2.1-1c0-2.7-0.1-6.4-0.4-10.8c-0.1-1.5-0.2-3.1-0.4-4.8c0.6-0.1,5.4-1.4,7.1-2.8 c1.6-1.3,3.4-3.4,3.3-5.6c0-2-1.6-3.7-3.7-3.7c-0.1,0-0.3,0-0.4,0c-3.1,0.4-5.7,5.4-6.2,8.2c0,0.2-0.2,2-0.2,3.1 c-0.1-0.7-0.1-1.3-0.2-2c-0.1-1.4-0.3-2.7-0.5-4.2c-0.1-0.7-0.2-1.4-0.4-2.1s-0.3-1.5-0.4-2.2c-0.4-1.7-0.8-3.4-1.3-5.1 c1.2-0.1,5.5-0.6,7.3-1.7s3.8-2.9,4.1-5.1c0.3-2-1.1-3.9-3.1-4.2c-0.1,0-0.3,0-0.4,0c-3.1-0.1-6.5,4.5-7.4,7.1 c-0.1,0.2-0.5,2.1-0.7,3.2c-0.3-1-0.6-2-1-3.1c-1-3-2.1-5.9-3.2-8.9l-1-2.7c0.4,0,5.5-0.5,7.5-1.7c1.8-1,3.8-2.9,4.1-5.1 c0.3-2-1-3.9-3.1-4.2c-0.1,0-0.3,0-0.4,0c-3.1-0.1-6.5,4.5-7.4,7.1c-0.1,0.2-0.7,3-0.8,3.8c-0.7-2-1.4-4-2-6 c-0.8-2.7-1.5-5.5-2-8.2c0.2,0,5.5-0.5,7.6-1.7c1.8-1.1,3.8-2.9,4.1-5.1c0.3-2-1.1-3.9-3.1-4.2c-0.1,0-0.3,0-0.4,0 c-3.1-0.1-6.5,4.5-7.4,7.1c-0.1,0.2-0.6,2.3-0.8,3.4h-0.2c-0.4-2.8-0.6-5.7-0.5-8.5c0-1.6,0.2-3.1,0.3-4.5c1,0,5.6,0,7.6-0.9 s4.1-2.4,4.6-4.6c0.5-2-0.6-4-2.6-4.6c-0.1,0-0.3-0.1-0.4-0.1c-3.1-0.4-6.9,3.8-8.1,6.3c-0.1,0.1-0.6,1.6-0.9,2.7 c0.1-0.7,0.1-1.3,0.2-2c0.3-2.4,0.8-4.5,1.2-6.4c0.2-1.1,0.5-2,0.7-2.9c1-0.5,4.9-2.6,6.3-4.2c1.4-1.6,2.5-4.1,2-6.2 c-0.4-2-2.4-3.3-4.4-2.9C74.8,121.3,74.6,121.3,74.4,121.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M17.8,169.7c2.4-0.1,7.3-2.6,7.4-2.6s-2.6-2.7-2.8-2.9c-2.2-1.7-7.5-3.8-10.1-2.1c-1.7,1.2-2.1,3.5-0.9,5.2 c0.1,0.1,0.2,0.2,0.2,0.3C13,169.3,15.7,169.8,17.8,169.7z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M46.4,231.1c0,0,14.9-35.8,23.2-34.3c8.3,1.5-14.3,57.1-14.3,57.1s26.2-49.4,44-49.4s-6.5,54.5-29.1,72.7 c0,0,35.7-38.4,56.5-30.1s-41.6,47.3-41.6,47.3s36.3-11.4,32.1-2.6s-15.5,10.4-15.5,10.4l41,2.1H0l32.1-3.1 c0,0-33.3-16.6-24.4-23.4s28.5,7.8,28.5,7.8S2.3,248.2,8.9,234.2s35.7,25.5,35.7,25.5s-23.8-50.4-19-59.2S46.4,231.1,46.4,231.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M46.4,231.1c0,0,14.9-35.8,23.2-34.3c8.3,1.5-14.3,57.1-14.3,57.1s26.2-49.4,44-49.4s-6.5,54.5-29.1,72.7 c0,0,35.7-38.4,56.5-30.1s-41.6,47.3-41.6,47.3s36.3-11.4,32.1-2.6s-15.5,10.4-15.5,10.4l41,2.1H0l32.1-3.1 c0,0-33.3-16.6-24.4-23.4s28.5,7.8,28.5,7.8S2.3,248.2,8.9,234.2s35.7,25.5,35.7,25.5s-23.8-50.4-19-59.2S46.4,231.1,46.4,231.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M41.6,232.9c13.1,38.6,13.1,66,13.1,66s-15.5,0.6-31.5-11.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M48.2,253.7c2.7-11.6,6.3-22.9,10.7-33.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M86.8,231.2l-33.3,49.4c0,0-22.6-19-30.3-29.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M54.1,292.4c0,0,35.1-16.6,49.4-26.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M346.3,146.5c-0.1,0,0.7-3.7,0.8-4c0.9-2.7,4.1-7.3,7.2-7.3c2.1,0.1,3.7,1.8,3.6,3.8c0,0.1,0,0.3,0,0.4 c-0.2,2.2-2.2,4.1-4,5.2C351.8,145.9,346.3,146.5,346.3,146.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M340.2,121.4c3,1.1,4.4,6.5,4.3,9.3c0,0.2-0.6,4-0.6,4h-0.1c0.2,0.9,0.5,1.8,0.7,2.8c0.4,1.9,0.9,4,1.3,6.4 c0.4,2.5,0.7,5.1,0.8,7.6c0.2,2.9,0.1,5.7-0.3,8.6v0.1c0.4-0.8,1.5-3.1,1.6-3.3c1.5-2.3,5.9-6,8.9-5.1c2,0.6,3.1,2.7,2.5,4.6 c0,0.1-0.1,0.3-0.1,0.4c-0.8,2.1-3.2,3.4-5.2,3.9c-2.3,0.6-7.3-0.1-7.7-0.2c-0.4,2.9-1.1,5.8-1.9,8.6c-0.5,1.6-1,3.3-1.5,4.9 c0.4-0.7,0.7-1.3,0.7-1.4c1.5-2.3,5.9-6,8.9-5.1c2,0.6,3.1,2.7,2.5,4.6c0,0.1-0.1,0.3-0.1,0.4c-0.8,2.1-3.2,3.4-5.2,3.9 s-6.4,0-7.5-0.1l-0.6,1.9c-1,3-2.1,6-3,8.9c-0.3,1-0.6,2.1-0.9,3.1c0.3-0.6,0.6-1.2,0.6-1.2c1.5-2.4,5.9-6,8.9-5.1 c2,0.6,3.1,2.7,2.5,4.6c0,0.1-0.1,0.2-0.1,0.4c-0.8,2.1-3.2,3.4-5.2,3.9s-5.9,0.1-7.3-0.1c-0.3,1.1-0.5,2.1-0.7,3.2 c-0.1,0.7-0.3,1.4-0.4,2.1l-0.3,2.1c-0.1,1.4-0.3,2.8-0.4,4.1c-0.1,0.9-0.1,1.8-0.2,2.7c0.3-1,1-3.1,1-3.2c1.1-2.2,2.8-4.1,4.8-5.5 c0.1-0.3,0.3-0.5,0.4-0.7c1.1-1.7,3.4-2.2,5.1-1.1c0.1,0.1,0.2,0.2,0.3,0.2c2.4,2,1.8,7.7,0.7,10.2c-0.1,0.1-1,1.7-1.5,2.7 c0.4-0.5,0.8-1,1.3-1.6c0.9-1.1,1.8-2.1,2.7-3.2l1.5-1.6c0.5-0.5,1.1-1,1.6-1.6c1.2-1.2,2.6-2.4,4-3.5c-0.9-0.8-4.2-3.5-5.1-5.4 s-1.6-4.5-0.6-6.5c0.8-1.9,3-2.7,4.9-1.8c0.1,0.1,0.2,0.1,0.4,0.2c2.6,1.7,2.9,7.3,2.2,10c0,0.2-0.8,2.1-1.2,3.1 c0.8-0.7,1.6-1.4,2.5-2c2.5-1.9,5-3.8,7.6-5.6l2.3-1.7c-0.3-0.3-4.3-3.5-5.4-5.6c-0.9-1.9-1.6-4.5-0.6-6.5c0.8-1.9,3-2.7,4.9-1.9 c0.1,0.1,0.2,0.1,0.4,0.2c2.7,1.7,2.9,7.3,2.2,10c0,0.2-1.1,2.9-1.4,3.6c1.7-1.3,3.4-2.5,5-3.9c2.2-1.8,4.3-3.7,6.2-5.8 c-0.1-0.1-4.3-3.5-5.4-5.6c-0.9-1.9-1.6-4.5-0.6-6.5c0.8-1.9,3-2.7,4.9-1.9c0.1,0.1,0.2,0.1,0.4,0.2c2.7,1.7,2.9,7.3,2.2,10 c0,0.2-0.8,2.3-1.2,3.2l0.1,0.1c1.9-2.1,3.6-4.4,5.1-6.8c0.8-1.3,1.6-2.6,2.2-3.9c-0.8-0.5-4.6-3-5.8-4.9s-2.1-4.3-1.3-6.4 c0.6-1.9,2.7-3,4.7-2.4c0.1,0,0.2,0.1,0.4,0.1c2.8,1.4,3.7,7,3.3,9.7c0,0.1-0.4,1.7-0.7,2.8c0.3-0.6,0.6-1.2,0.9-1.8 c1-2.1,1.9-4.1,2.5-5.9c0.4-1,0.7-2,1-2.8c-0.5-0.9-2.7-4.8-2.9-7s0.1-4.8,1.8-6.3c1.5-1.4,3.8-1.4,5.2,0c0.1,0.1,0.2,0.2,0.3,0.3 c1.9,2.5,0.1,7.9-1.5,10.2c-0.1,0.2-2.7,3-2.7,3v-0.1c-0.3,0.9-0.6,1.8-0.9,2.7c-0.7,1.8-1.4,3.9-2.4,6c-1,2.3-2.2,4.6-3.5,6.8 c-1.5,2.5-3.1,4.8-5,7l-0.1,0.1c0.8-0.5,3-1.8,3.2-1.8c2.6-1.1,8.2-1.7,10.3,0.6c1.3,1.6,1.1,3.9-0.5,5.2c-0.1,0.1-0.2,0.2-0.3,0.2 c-1.8,1.3-4.5,1-6.5,0.4c-2.2-0.7-6-4.1-6.3-4.4c-2,2.2-4.1,4.2-6.3,6.1c-1.3,1.1-2.6,2.2-4,3.3c0.7-0.4,1.3-0.7,1.4-0.8 c2.6-1.1,8.2-1.7,10.2,0.6c1.3,1.6,1.1,3.9-0.5,5.2c-0.1,0.1-0.2,0.2-0.3,0.2c-1.8,1.3-4.5,1-6.5,0.4s-5.3-3.5-6.2-4.3 c-0.5,0.4-1,0.8-1.6,1.2c-2.5,1.9-5,3.8-7.5,5.8c-0.9,0.7-1.7,1.4-2.5,2.1l1.2-0.7c2.6-1.1,8.2-1.7,10.2,0.6 c1.3,1.6,1.1,3.9-0.5,5.2c-0.1,0.1-0.2,0.2-0.3,0.2c-1.8,1.3-4.5,1-6.5,0.4s-5-3.2-6-4.1c-0.8,0.7-1.6,1.5-2.4,2.2 c-0.5,0.5-1,1-1.5,1.6l-1.4,1.6c-0.9,1.1-1.8,2.1-2.6,3.2c-0.6,0.7-1.1,1.5-1.7,2.2c0.8-0.7,2.5-2,2.7-2.1c2.4-1.5,7.8-3,10.2-0.9 c1.5,1.4,1.7,3.7,0.3,5.2c-0.1,0.1-0.2,0.2-0.3,0.3c-1.6,1.5-4.3,1.7-6.4,1.4c-2.3-0.4-6.4-3-6.9-3.4c-0.9,1.2-1.8,2.3-2.6,3.4 c-2.8,3.8-4.9,7.1-6.4,9.5c0,0.1-0.1,0.2-0.1,0.2l-1.9-0.9l0.3-0.5c1.5-2.3,3.8-5.6,6.7-9.4c0.9-1.2,1.9-2.5,2.9-3.8 c-1.1-1.2-2.1-2.4-3-3.7c-2.2,0.9-6.8,0.9-7.4,0.9c-0.1,1.5-0.2,2.9-0.2,4.3c-0.2,4.7-0.2,8.7-0.1,11.4v0.3l-2.1-1 c0-2.7,0.1-6.4,0.4-10.8c0.1-1.5,0.2-3.1,0.4-4.8c-0.6-0.1-5.4-1.4-7.2-2.8c-1.6-1.3-3.4-3.4-3.3-5.6c0-2,1.6-3.7,3.7-3.7 c0.1,0,0.3,0,0.4,0c3.1,0.4,5.7,5.4,6.2,8.2c0,0.2,0.2,2,0.2,3.1c0.1-0.7,0.1-1.3,0.2-2c0.1-1.4,0.3-2.7,0.5-4.2 c0.1-0.7,0.2-1.4,0.3-2.1s0.3-1.5,0.5-2.2c0.4-1.7,0.8-3.4,1.4-5.1c-1.2-0.1-5.5-0.6-7.3-1.7s-3.8-2.9-4.1-5.1 c-0.3-2,1-3.9,3.1-4.2c0.1,0,0.3,0,0.4,0c3.1-0.1,6.5,4.5,7.4,7.1c0.1,0.2,0.5,2.1,0.7,3.2c0.3-1,0.6-2,1-3.1c1-3,2.1-5.9,3.2-8.9 c0.3-0.9,0.7-1.8,1-2.7c-0.4,0-5.5-0.5-7.5-1.7c-1.8-1-3.8-2.9-4.1-5.1c-0.3-2,1.1-3.9,3.1-4.2c0.1,0,0.3,0,0.4,0 c3.1-0.1,6.5,4.5,7.4,7.1c0.1,0.2,0.7,3,0.8,3.8c0.7-2,1.4-4,2-6c0.8-2.7,1.5-5.5,2-8.2c-0.2,0-5.5-0.5-7.6-1.7 c-1.8-1.1-3.8-2.9-4.1-5.1c-0.3-2,1-3.9,3.1-4.2c0.1,0,0.3,0,0.4,0c3.1-0.1,6.5,4.5,7.4,7.1c0.1,0.2,0.6,2.3,0.8,3.4h0.2 c0.4-2.8,0.6-5.7,0.5-8.5c0-1.6-0.1-3.1-0.3-4.5c-1,0-5.5,0-7.5-0.9s-4.1-2.4-4.6-4.6c-0.5-2,0.6-4,2.6-4.6c0.1,0,0.3-0.1,0.4-0.1 c3.1-0.4,6.9,3.8,8.1,6.3c0.1,0.1,0.6,1.6,0.9,2.7c-0.1-0.7-0.1-1.3-0.2-2c-0.3-2.4-0.8-4.5-1.1-6.4c-0.2-1.1-0.5-2-0.7-2.9 c-1-0.5-4.9-2.6-6.3-4.2s-2.5-4.1-2-6.2c0.5-2,2.4-3.3,4.4-2.8C340,121.3,340.1,121.3,340.2,121.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M396.9,169.7c-2.5-0.1-7.4-2.6-7.4-2.6s2.6-2.7,2.8-2.9c2.2-1.7,7.5-3.8,10.1-2.1c1.7,1.2,2.1,3.5,0.9,5.2 c-0.1,0.1-0.2,0.2-0.3,0.3C401.7,169.3,399,169.8,396.9,169.7z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M346.3,146.5c-0.1,0,0.7-3.7,0.8-4c0.9-2.7,4.1-7.3,7.2-7.3c2.1,0.1,3.7,1.8,3.6,3.8c0,0.1,0,0.3,0,0.4 c-0.2,2.2-2.2,4.1-4,5.2C351.8,145.9,346.3,146.5,346.3,146.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M340.2,121.4c3,1.1,4.4,6.5,4.3,9.3c0,0.2-0.6,4-0.6,4h-0.1c0.2,0.9,0.5,1.8,0.7,2.8c0.4,1.9,0.9,4,1.3,6.4 c0.4,2.5,0.7,5.1,0.8,7.6c0.2,2.9,0.1,5.7-0.3,8.6v0.1c0.4-0.8,1.5-3.1,1.6-3.3c1.5-2.3,5.9-6,8.9-5.1c2,0.6,3.1,2.7,2.5,4.6 c0,0.1-0.1,0.3-0.1,0.4c-0.8,2.1-3.2,3.4-5.2,3.9c-2.3,0.6-7.3-0.1-7.7-0.2c-0.4,2.9-1.1,5.8-1.9,8.6c-0.5,1.6-1,3.3-1.5,4.9 c0.4-0.7,0.7-1.3,0.7-1.4c1.5-2.3,5.9-6,8.9-5.1c2,0.6,3.1,2.7,2.5,4.6c0,0.1-0.1,0.3-0.1,0.4c-0.8,2.1-3.2,3.4-5.2,3.9 s-6.4,0-7.5-0.1l-0.6,1.9c-1,3-2.1,6-3,8.9c-0.3,1-0.6,2.1-0.9,3.1c0.3-0.6,0.6-1.2,0.6-1.2c1.5-2.4,5.9-6,8.9-5.1 c2,0.6,3.1,2.7,2.5,4.6c0,0.1-0.1,0.2-0.1,0.4c-0.8,2.1-3.2,3.4-5.2,3.9s-5.9,0.1-7.3-0.1c-0.3,1.1-0.5,2.1-0.7,3.2 c-0.1,0.7-0.3,1.4-0.4,2.1l-0.3,2.1c-0.1,1.4-0.3,2.8-0.4,4.1c-0.1,0.9-0.1,1.8-0.2,2.7c0.3-1,1-3.1,1-3.2 c1.1-2.2,2.8-4.1,4.8-5.5c0.1-0.3,0.3-0.5,0.4-0.7c1.1-1.7,3.4-2.2,5.1-1.1c0.1,0.1,0.2,0.2,0.3,0.2c2.4,2,1.8,7.7,0.7,10.2 c-0.1,0.1-1,1.7-1.5,2.7c0.4-0.5,0.8-1,1.3-1.6c0.9-1.1,1.8-2.1,2.7-3.2l1.5-1.6c0.5-0.5,1.1-1,1.6-1.6c1.2-1.2,2.6-2.4,4-3.5 c-0.9-0.8-4.2-3.5-5.1-5.4s-1.6-4.5-0.6-6.5c0.8-1.9,3-2.7,4.9-1.8c0.1,0.1,0.2,0.1,0.4,0.2c2.6,1.7,2.9,7.3,2.2,10 c0,0.2-0.8,2.1-1.2,3.1c0.8-0.7,1.6-1.4,2.5-2c2.5-1.9,5-3.8,7.6-5.6l2.3-1.7c-0.3-0.3-4.3-3.5-5.4-5.6c-0.9-1.9-1.6-4.5-0.6-6.5 c0.8-1.9,3-2.7,4.9-1.9c0.1,0.1,0.2,0.1,0.4,0.2c2.7,1.7,2.9,7.3,2.2,10c0,0.2-1.1,2.9-1.4,3.6c1.7-1.3,3.4-2.5,5-3.9 c2.2-1.8,4.3-3.7,6.2-5.8c-0.1-0.1-4.3-3.5-5.4-5.6c-0.9-1.9-1.6-4.5-0.6-6.5c0.8-1.9,3-2.7,4.9-1.9c0.1,0.1,0.2,0.1,0.4,0.2 c2.7,1.7,2.9,7.3,2.2,10c0,0.2-0.8,2.3-1.2,3.2l0.1,0.1c1.9-2.1,3.6-4.4,5.1-6.8c0.8-1.3,1.6-2.6,2.2-3.9c-0.8-0.5-4.6-3-5.8-4.9 s-2.1-4.3-1.3-6.4c0.6-1.9,2.7-3,4.7-2.4c0.1,0,0.2,0.1,0.4,0.1c2.8,1.4,3.7,7,3.3,9.7c0,0.1-0.4,1.7-0.7,2.8 c0.3-0.6,0.6-1.2,0.9-1.8c1-2.1,1.9-4.1,2.5-5.9c0.4-1,0.7-2,1-2.8c-0.5-0.9-2.7-4.8-2.9-7s0.1-4.8,1.8-6.3c1.5-1.4,3.8-1.4,5.2,0 c0.1,0.1,0.2,0.2,0.3,0.3c1.9,2.5,0.1,7.9-1.5,10.2c-0.1,0.2-2.7,3-2.7,3v-0.1c-0.3,0.9-0.6,1.8-0.9,2.7c-0.7,1.8-1.4,3.9-2.4,6 c-1,2.3-2.2,4.6-3.5,6.8c-1.5,2.5-3.1,4.8-5,7l-0.1,0.1c0.8-0.5,3-1.8,3.2-1.8c2.6-1.1,8.2-1.7,10.3,0.6c1.3,1.6,1.1,3.9-0.5,5.2 c-0.1,0.1-0.2,0.2-0.3,0.2c-1.8,1.3-4.5,1-6.5,0.4c-2.2-0.7-6-4.1-6.3-4.4c-2,2.2-4.1,4.2-6.3,6.1c-1.3,1.1-2.6,2.2-4,3.3 c0.7-0.4,1.3-0.7,1.4-0.8c2.6-1.1,8.2-1.7,10.2,0.6c1.3,1.6,1.1,3.9-0.5,5.2c-0.1,0.1-0.2,0.2-0.3,0.2c-1.8,1.3-4.5,1-6.5,0.4 s-5.3-3.5-6.2-4.3c-0.5,0.4-1,0.8-1.6,1.2c-2.5,1.9-5,3.8-7.5,5.8c-0.9,0.7-1.7,1.4-2.5,2.1l1.2-0.7c2.6-1.1,8.2-1.7,10.2,0.6 c1.3,1.6,1.1,3.9-0.5,5.2c-0.1,0.1-0.2,0.2-0.3,0.2c-1.8,1.3-4.5,1-6.5,0.4s-5-3.2-6-4.1c-0.8,0.7-1.6,1.5-2.4,2.2 c-0.5,0.5-1,1-1.5,1.6l-1.4,1.6c-0.9,1.1-1.8,2.1-2.6,3.2c-0.6,0.7-1.1,1.5-1.7,2.2c0.8-0.7,2.5-2,2.7-2.1c2.4-1.5,7.8-3,10.2-0.9 c1.5,1.4,1.7,3.7,0.3,5.2c-0.1,0.1-0.2,0.2-0.3,0.3c-1.6,1.5-4.3,1.7-6.4,1.4c-2.3-0.4-6.4-3-6.9-3.4c-0.9,1.2-1.8,2.3-2.6,3.4 c-2.8,3.8-4.9,7.1-6.4,9.5c0,0.1-0.1,0.2-0.1,0.2l-1.9-0.9l0.3-0.5c1.5-2.3,3.8-5.6,6.7-9.4c0.9-1.2,1.9-2.5,2.9-3.8 c-1.1-1.2-2.1-2.4-3-3.7c-2.2,0.9-6.8,0.9-7.4,0.9c-0.1,1.5-0.2,2.9-0.2,4.3c-0.2,4.7-0.2,8.7-0.1,11.4v0.3l-2.1-1 c0-2.7,0.1-6.4,0.4-10.8c0.1-1.5,0.2-3.1,0.4-4.8c-0.6-0.1-5.4-1.4-7.2-2.8c-1.6-1.3-3.4-3.4-3.3-5.6c0-2,1.6-3.7,3.7-3.7 c0.1,0,0.3,0,0.4,0c3.1,0.4,5.7,5.4,6.2,8.2c0,0.2,0.2,2,0.2,3.1c0.1-0.7,0.1-1.3,0.2-2c0.1-1.4,0.3-2.7,0.5-4.2 c0.1-0.7,0.2-1.4,0.3-2.1s0.3-1.5,0.5-2.2c0.4-1.7,0.8-3.4,1.4-5.1c-1.2-0.1-5.5-0.6-7.3-1.7s-3.8-2.9-4.1-5.1 c-0.3-2,1-3.9,3.1-4.2c0.1,0,0.3,0,0.4,0c3.1-0.1,6.5,4.5,7.4,7.1c0.1,0.2,0.5,2.1,0.7,3.2c0.3-1,0.6-2,1-3.1c1-3,2.1-5.9,3.2-8.9 c0.3-0.9,0.7-1.8,1-2.7c-0.4,0-5.5-0.5-7.5-1.7c-1.8-1-3.8-2.9-4.1-5.1c-0.3-2,1.1-3.9,3.1-4.2c0.1,0,0.3,0,0.4,0 c3.1-0.1,6.5,4.5,7.4,7.1c0.1,0.2,0.7,3,0.8,3.8c0.7-2,1.4-4,2-6c0.8-2.7,1.5-5.5,2-8.2c-0.2,0-5.5-0.5-7.6-1.7 c-1.8-1.1-3.8-2.9-4.1-5.1c-0.3-2,1-3.9,3.1-4.2c0.1,0,0.3,0,0.4,0c3.1-0.1,6.5,4.5,7.4,7.1c0.1,0.2,0.6,2.3,0.8,3.4h0.2 c0.4-2.8,0.6-5.7,0.5-8.5c0-1.6-0.1-3.1-0.3-4.5c-1,0-5.5,0-7.5-0.9s-4.1-2.4-4.6-4.6c-0.5-2,0.6-4,2.6-4.6c0.1,0,0.3-0.1,0.4-0.1 c3.1-0.4,6.9,3.8,8.1,6.3c0.1,0.1,0.6,1.6,0.9,2.7c-0.1-0.7-0.1-1.3-0.2-2c-0.3-2.4-0.8-4.5-1.1-6.4c-0.2-1.1-0.5-2-0.7-2.9 c-1-0.5-4.9-2.6-6.3-4.2s-2.5-4.1-2-6.2c0.5-2,2.4-3.3,4.4-2.8C340,121.3,340.1,121.3,340.2,121.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M396.9,169.7c-2.5-0.1-7.4-2.6-7.4-2.6s2.6-2.7,2.8-2.9c2.2-1.7,7.5-3.8,10.1-2.1c1.7,1.2,2.1,3.5,0.9,5.2 c-0.1,0.1-0.2,0.2-0.3,0.3C401.7,169.3,399,169.8,396.9,169.7z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M368.3,231.1c0,0-14.9-35.8-23.2-34.3s14.3,57.1,14.3,57.1s-26.2-49.4-44-49.4s6.5,54.5,29.1,72.7 c0,0-35.7-38.4-56.5-30.1s41.7,47.3,41.7,47.3s-36.3-11.4-32.1-2.6s15.5,10.4,15.5,10.4l-41,2.1h142.6l-32.1-3.1 c0,0,33.3-16.6,24.4-23.4s-28.5,7.8-28.5,7.8s33.9-37.4,27.4-51.4s-35.7,25.5-35.7,25.5s23.8-50.4,19-59.2S368.3,231.1,368.3,231.1 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M368.3,231.1c0,0-14.9-35.8-23.2-34.3s14.3,57.1,14.3,57.1s-26.2-49.4-44-49.4s6.5,54.5,29.1,72.7 c0,0-35.7-38.4-56.5-30.1s41.7,47.3,41.7,47.3s-36.3-11.4-32.1-2.6s15.5,10.4,15.5,10.4l-41,2.1h142.6l-32.1-3.1 c0,0,33.3-16.6,24.4-23.4s-28.5,7.8-28.5,7.8s33.9-37.4,27.4-51.4s-35.7,25.5-35.7,25.5s23.8-50.4,19-59.2S368.3,231.1,368.3,231.1 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M373.1,232.9c-13.1,38.6-13.1,66-13.1,66s15.5,0.6,31.5-11.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M366.5,253.7c-2.7-11.6-6.3-22.9-10.7-33.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M327.9,231.2l33.3,49.4c0,0,22.6-19,30.3-29.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M360.6,292.4c0,0-35.1-16.6-49.4-26.2"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Page--inject-7"
  }, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "138.4,51.7 130.2,38.7 58.3,38.7 58.3,51.7 58.3,56.4 58.3,273.4 354.5,273.4 354.5,51.7  "
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 60.5,
    y: 57.7,
    className: "st3",
    width: 292,
    height: 210.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: 60.5,
    y: 57.7,
    width: 292,
    height: 210.9
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000079471651403599176780000005793639166064478103_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000079471651403599176780000005793639166064478103_)"
    }
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 347.2,
    y: 55.9,
    className: "st8",
    width: 6.8,
    height: 214.3
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 347.2,
    y: 185.5,
    className: "st8",
    width: 6.8,
    height: 83
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 59.3,
    y: 54.9,
    className: "st9",
    width: 293.6,
    height: 11.5
  }))))), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 60.5,
    y: 57.7,
    className: "st5",
    width: 292,
    height: 210.9
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "st10"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M212.6,77.4h-20.4c-1,0-1.8-0.8-1.8-1.8l0,0l0,0c0-1,0.8-1.8,1.8-1.8l0,0h20.4c1,0,1.8,0.8,1.8,1.8l0,0l0,0 C214.4,76.6,213.6,77.4,212.6,77.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.5,77.4h-20.4c-1,0-1.8-0.8-1.8-1.8l0,0c0-1,0.8-1.8,1.8-1.8h20.4c1,0,1.8,0.8,1.8,1.8l0,0 C255.3,76.6,254.5,77.4,253.5,77.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.4,77.4H274c-1,0-1.8-0.8-1.8-1.8l0,0c0-1,0.8-1.8,1.8-1.8h20.4c1,0,1.8,0.8,1.8,1.8l0,0 C296.2,76.6,295.4,77.4,294.4,77.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.2,77.4h-20.4c-1,0-1.8-0.8-1.8-1.8l0,0c0-1,0.8-1.8,1.8-1.8l0,0h20.4c1,0,1.8,0.8,1.8,1.8l0,0 C337,76.6,336.2,77.4,335.2,77.4z"
  }))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st11",
    x1: 88.1,
    y1: 163.5,
    x2: 118.9,
    y2: 163.5
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 118.4,
    y1: 168.3,
    x2: 121.8,
    y2: 168.3
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 99.1,
    y1: 168.3,
    x2: 116.3,
    y2: 168.3
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 85.7,
    y1: 168.3,
    x2: 97.2,
    y2: 168.3
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 107.6,
    y1: 173.1,
    x2: 121.8,
    y2: 173.1
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 99.9,
    y1: 173.1,
    x2: 105.4,
    y2: 173.1
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 85.7,
    y1: 173.1,
    x2: 97.4,
    y2: 173.1
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 93.4,
    y1: 177.9,
    x2: 121.8,
    y2: 177.9
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 85.7,
    y1: 177.9,
    x2: 90.7,
    y2: 177.9
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 114.7,
    y1: 182.7,
    x2: 121.8,
    y2: 182.7
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 101.3,
    y1: 182.7,
    x2: 112.3,
    y2: 182.7
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 85.7,
    y1: 182.7,
    x2: 99.1,
    y2: 182.7
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 97.4,
    y1: 187.5,
    x2: 121.8,
    y2: 187.5
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 85.7,
    y1: 187.5,
    x2: 95.2,
    y2: 187.5
  })), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    className: "st11",
    x1: 158.5,
    y1: 163.5,
    x2: 189.3,
    y2: 163.5
  })), _line16 || (_line16 = /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 188.8,
    y1: 168.3,
    x2: 192.2,
    y2: 168.3
  })), _line17 || (_line17 = /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 169.5,
    y1: 168.3,
    x2: 186.8,
    y2: 168.3
  })), _line18 || (_line18 = /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 156.1,
    y1: 168.3,
    x2: 167.6,
    y2: 168.3
  })), _line19 || (_line19 = /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 178,
    y1: 173.1,
    x2: 192.2,
    y2: 173.1
  })), _line20 || (_line20 = /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 170.3,
    y1: 173.1,
    x2: 175.8,
    y2: 173.1
  })), _line21 || (_line21 = /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 156.1,
    y1: 173.1,
    x2: 167.8,
    y2: 173.1
  })), _line22 || (_line22 = /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 163.8,
    y1: 177.9,
    x2: 192.2,
    y2: 177.9
  })), _line23 || (_line23 = /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 156.1,
    y1: 177.9,
    x2: 161.1,
    y2: 177.9
  })), _line24 || (_line24 = /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 185.1,
    y1: 182.7,
    x2: 192.2,
    y2: 182.7
  })), _line25 || (_line25 = /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 171.7,
    y1: 182.7,
    x2: 182.7,
    y2: 182.7
  })), _line26 || (_line26 = /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 156.1,
    y1: 182.7,
    x2: 169.5,
    y2: 182.7
  })), _line27 || (_line27 = /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 167.8,
    y1: 187.5,
    x2: 192.2,
    y2: 187.5
  })), _line28 || (_line28 = /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 156.1,
    y1: 187.5,
    x2: 165.6,
    y2: 187.5
  })), _line29 || (_line29 = /*#__PURE__*/React.createElement("line", {
    className: "st11",
    x1: 228.9,
    y1: 163.5,
    x2: 259.7,
    y2: 163.5
  })), _line30 || (_line30 = /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 259.2,
    y1: 168.3,
    x2: 262.6,
    y2: 168.3
  })), _line31 || (_line31 = /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 239.9,
    y1: 168.3,
    x2: 257.2,
    y2: 168.3
  })), _line32 || (_line32 = /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 226.5,
    y1: 168.3,
    x2: 238,
    y2: 168.3
  })), _line33 || (_line33 = /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 248.4,
    y1: 173.1,
    x2: 262.6,
    y2: 173.1
  })), _line34 || (_line34 = /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 240.7,
    y1: 173.1,
    x2: 246.2,
    y2: 173.1
  })), _line35 || (_line35 = /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 226.5,
    y1: 173.1,
    x2: 238.2,
    y2: 173.1
  })), _line36 || (_line36 = /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 234.2,
    y1: 177.9,
    x2: 262.6,
    y2: 177.9
  })), _line37 || (_line37 = /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 226.5,
    y1: 177.9,
    x2: 231.5,
    y2: 177.9
  })), _line38 || (_line38 = /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 255.5,
    y1: 182.7,
    x2: 262.6,
    y2: 182.7
  })), _line39 || (_line39 = /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 242.1,
    y1: 182.7,
    x2: 253.1,
    y2: 182.7
  })), _line40 || (_line40 = /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 226.5,
    y1: 182.7,
    x2: 239.9,
    y2: 182.7
  })), _line41 || (_line41 = /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 238.2,
    y1: 187.5,
    x2: 262.6,
    y2: 187.5
  })), _line42 || (_line42 = /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 226.5,
    y1: 187.5,
    x2: 236,
    y2: 187.5
  })), _line43 || (_line43 = /*#__PURE__*/React.createElement("line", {
    className: "st11",
    x1: 299.3,
    y1: 163.5,
    x2: 330.1,
    y2: 163.5
  })), _line44 || (_line44 = /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 329.6,
    y1: 168.3,
    x2: 333,
    y2: 168.3
  })), _line45 || (_line45 = /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 310.3,
    y1: 168.3,
    x2: 327.6,
    y2: 168.3
  })), _line46 || (_line46 = /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 296.9,
    y1: 168.3,
    x2: 308.4,
    y2: 168.3
  })), _line47 || (_line47 = /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 318.8,
    y1: 173.1,
    x2: 333,
    y2: 173.1
  })), _line48 || (_line48 = /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 311.1,
    y1: 173.1,
    x2: 316.6,
    y2: 173.1
  })), _line49 || (_line49 = /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 296.9,
    y1: 173.1,
    x2: 308.6,
    y2: 173.1
  })), _line50 || (_line50 = /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 304.6,
    y1: 177.9,
    x2: 333,
    y2: 177.9
  })), _line51 || (_line51 = /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 296.9,
    y1: 177.9,
    x2: 301.9,
    y2: 177.9
  })), _line52 || (_line52 = /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 325.9,
    y1: 182.7,
    x2: 333,
    y2: 182.7
  })), _line53 || (_line53 = /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 312.5,
    y1: 182.7,
    x2: 323.5,
    y2: 182.7
  })), _line54 || (_line54 = /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 296.9,
    y1: 182.7,
    x2: 310.3,
    y2: 182.7
  })), _line55 || (_line55 = /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 308.6,
    y1: 187.5,
    x2: 333,
    y2: 187.5
  })), _line56 || (_line56 = /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 296.9,
    y1: 187.5,
    x2: 306.4,
    y2: 187.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M342.5,148h-272V91.9h272V148z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M342.5,148h-272V91.9h272V148z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M273.6,148H139.3V91.9h134.3L273.6,148L273.6,148z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M273.6,148H139.3V91.9h134.3L273.6,148L273.6,148z"
  })), _line57 || (_line57 = /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 245,
    y1: 132.1,
    x2: 254.1,
    y2: 132.1
  })), _line58 || (_line58 = /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 192.3,
    y1: 132.1,
    x2: 239.1,
    y2: 132.1
  })), _line59 || (_line59 = /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 157.6,
    y1: 132.1,
    x2: 188.8,
    y2: 132.1
  })), _line60 || (_line60 = /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 216.4,
    y1: 137.3,
    x2: 254.7,
    y2: 137.3
  })), _line61 || (_line61 = /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 196.2,
    y1: 137.3,
    x2: 211.1,
    y2: 137.3
  })), _line62 || (_line62 = /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 157.6,
    y1: 137.3,
    x2: 189.3,
    y2: 137.3
  })), _line63 || (_line63 = /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 178.4,
    y1: 117.8,
    x2: 255.3,
    y2: 117.8
  })), _line64 || (_line64 = /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 158.1,
    y1: 117.8,
    x2: 171.7,
    y2: 117.8
  })), _line65 || (_line65 = /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 236.3,
    y1: 122.6,
    x2: 255.3,
    y2: 122.6
  })), _line66 || (_line66 = /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 199.9,
    y1: 122.6,
    x2: 229.7,
    y2: 122.6
  })), _line67 || (_line67 = /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 157.6,
    y1: 122.6,
    x2: 193.8,
    y2: 122.6
  })), _line68 || (_line68 = /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 189.4,
    y1: 127.4,
    x2: 255.3,
    y2: 127.4
  })), _line69 || (_line69 = /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 157.6,
    y1: 127.4,
    x2: 183.3,
    y2: 127.4
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M342.5,267.9h-272v-56.1h272V267.9z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M342.5,267.9h-272v-56.1h272V267.9z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M180.4,109.4h-4.6l-0.9,2.6h-2.8l4.8-12.8h2.4l4.8,12.8h-2.8L180.4,109.4z M176.5,107.3h3.2l-1.6-4.8 L176.5,107.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M193.7,107.4c0,1.5-0.3,2.7-1,3.6s-1.6,1.3-2.7,1.3c-1,0-1.9-0.4-2.5-1.2l-0.1,1h-2.3V98.6h2.5v4.8 c0.6-0.7,1.4-1,2.3-1c1.2,0,2.1,0.4,2.7,1.3s1,2.1,1,3.6v0.1H193.7z M191.1,107.2c0-1-0.2-1.7-0.5-2.1s-0.8-0.7-1.4-0.7 c-0.8,0-1.4,0.3-1.7,1v3.8c0.3,0.7,0.9,1,1.7,1s1.4-0.4,1.6-1.2C191.1,108.6,191.1,108,191.1,107.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M194.8,107.2c0-0.9,0.2-1.8,0.5-2.5s0.9-1.3,1.6-1.7s1.5-0.6,2.4-0.6c1.3,0,2.3,0.4,3.1,1.2s1.3,1.9,1.4,3.2 v0.7c0,1.5-0.4,2.6-1.2,3.5s-1.9,1.3-3.3,1.3s-2.5-0.4-3.3-1.3s-1.2-2.1-1.2-3.6V107.2z M197.4,107.4c0,0.9,0.2,1.6,0.5,2.1 s0.8,0.7,1.5,0.7c0.6,0,1.1-0.2,1.4-0.7c0.3-0.5,0.5-1.2,0.5-2.3c0-0.9-0.2-1.6-0.5-2.1s-0.8-0.7-1.5-0.7c-0.6,0-1.1,0.2-1.4,0.7 C197.5,105.6,197.4,106.3,197.4,107.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M211.1,111.1c-0.6,0.8-1.5,1.1-2.6,1.1c-1,0-1.8-0.3-2.3-0.9s-0.8-1.4-0.8-2.6v-6.2h2.5v6.2 c0,1,0.5,1.5,1.4,1.5s1.5-0.3,1.8-0.9v-6.7h2.5v9.5h-2.4L211.1,111.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M218.5,100.2v2.3h1.6v1.9h-1.6v4.7c0,0.4,0.1,0.6,0.2,0.8s0.4,0.2,0.8,0.2c0.3,0,0.5,0,0.7-0.1v1.9 c-0.5,0.2-1,0.2-1.5,0.2c-1.8,0-2.7-0.9-2.7-2.7v-5.1h-1.4v-1.9h1.4v-2.3h2.5V100.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M235.9,99.2v8.4c0,1.4-0.4,2.5-1.3,3.3s-2.1,1.2-3.6,1.2s-2.7-0.4-3.6-1.2s-1.3-1.9-1.3-3.3v-8.5h2.6v8.4 c0,0.8,0.2,1.4,0.6,1.8s1,0.6,1.7,0.6c1.5,0,2.2-0.8,2.3-2.3v-8.5h2.6V99.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M243,109.4c0-0.3-0.2-0.6-0.5-0.7s-0.8-0.3-1.5-0.5c-2.3-0.5-3.4-1.4-3.4-2.9c0-0.8,0.4-1.5,1.1-2.1 s1.6-0.8,2.7-0.8c1.2,0,2.2,0.3,2.9,0.9s1.1,1.3,1.1,2.2h-2.5c0-0.4-0.1-0.7-0.4-0.9s-0.6-0.4-1.1-0.4c-0.4,0-0.8,0.1-1,0.3 s-0.4,0.4-0.4,0.7s0.1,0.5,0.4,0.7s0.7,0.3,1.3,0.4s1.2,0.3,1.6,0.4c1.3,0.5,2,1.3,2,2.6c0,0.9-0.4,1.6-1.1,2.1s-1.7,0.8-2.9,0.8 c-0.8,0-1.5-0.1-2.1-0.4s-1.1-0.7-1.5-1.2s-0.5-1-0.5-1.6h2.4c0,0.5,0.2,0.8,0.5,1s0.7,0.4,1.2,0.4s0.9-0.1,1.1-0.3 S243,109.7,243,109.4z"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M273.5,267.9H139.2v-56.1h134.3V267.9z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M273.6,267.9H139.3v-56.1h134.3L273.6,267.9L273.6,267.9z"
  })), _line70 || (_line70 = /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 227.5,
    y1: 230,
    x2: 255.1,
    y2: 230
  })), _line71 || (_line71 = /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 227.5,
    y1: 246.6,
    x2: 255.1,
    y2: 246.6
  })), _line72 || (_line72 = /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 156.1,
    y1: 230,
    x2: 197.5,
    y2: 230
  })), _line73 || (_line73 = /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 156.1,
    y1: 246.6,
    x2: 197.5,
    y2: 246.6
  })), _line74 || (_line74 = /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 238,
    y1: 224.8,
    x2: 255.4,
    y2: 224.8
  })), _line75 || (_line75 = /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 238.1,
    y1: 241,
    x2: 255.5,
    y2: 241
  })), _line76 || (_line76 = /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 156.1,
    y1: 224.8,
    x2: 233.1,
    y2: 224.8
  })), _line77 || (_line77 = /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 156.1,
    y1: 241,
    x2: 233.1,
    y2: 241
  })), _line78 || (_line78 = /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 178.4,
    y1: 235.5,
    x2: 214.4,
    y2: 235.5
  })), _line79 || (_line79 = /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 178.4,
    y1: 252.1,
    x2: 214.4,
    y2: 252.1
  })), _line80 || (_line80 = /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 201.9,
    y1: 230,
    x2: 223.2,
    y2: 230
  })), _line81 || (_line81 = /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 201.9,
    y1: 246.6,
    x2: 223.2,
    y2: 246.6
  })), _line82 || (_line82 = /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 156.3,
    y1: 235.3,
    x2: 173.9,
    y2: 235.3
  })), _line83 || (_line83 = /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 156.1,
    y1: 252.1,
    x2: 173.7,
    y2: 252.1
  })), _line84 || (_line84 = /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 220.1,
    y1: 235.5,
    x2: 255.5,
    y2: 235.5
  })), _line85 || (_line85 = /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 220.1,
    y1: 252.1,
    x2: 255.5,
    y2: 252.1
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutuspageBro);
export default __webpack_public_path__ + "static/media/About us page-bro.995e148da918b092a04243c98ddf03d4.svg";
export { ForwardRef as ReactComponent };